
<template>
  <main>
    <app-error v-if="loadingError && !orderLoaded" class="kub-max-width"></app-error>
    <b-container v-else-if="!loadingError && !orderLoaded" fluid :class="{'kub-main': lg}">
      <app-shadow></app-shadow>
      <b-card no-body style="border:none;" class="kub-max-width">
        <b-tabs v-model="changeTabIndex" pills card nav-wrapper-class="sticky-top kub-main-selection kub-neg-margin">
          <b-tab disabled class="ml-3 mr-auto" title-item-class="d-flex align-items-center" title-link-class="pt-0 pb-0">
            <template #title>
              <div class="d-flex align-items-end">
                <b-img :src="header.kubLogoDark" id="kub-logo-dark" alt="Kubulus Logo dunkel" :class="{'d-none': logoVisible}"></b-img>
              </div>
            </template>
          </b-tab>
          <b-tab active :title-item-class="[{'ml-auto': true}, {'kub-main-selection-tabs': true}, {'d-none': changeTabIndex === 1}]" @click="changeView({x: 0, y: 0})">
            <template #title>
              <div class="d-flex align-items-center">
                <b-icon icon="tools" :class="{'mr-2': !xs}" :font-scale="md ? 1 : 1.5"></b-icon>
                <span class="kub-main-selection-heading">{{headings.config}}</span>
              </div>
            </template>
            <b-card-text>
              <app-description></app-description>
              <app-config-progress></app-config-progress>
              <section data-nosnippet>
                <b-row>
                  <b-col order="1" order-lg="0" cols="12" lg="6" :class="{'pr-4': lg}">
                    <b-row align-h="between">
                      <b-col cols="auto" class="pt-2">
                        <h2 id="kub-heading-setup" class="kub-color">{{headings.setup}}</h2>
                      </b-col>
                      <b-col cols="auto">
                        <b-button v-if="formComplete" block class="kub-btn mb-2 d-none d-lg-block" v-b-modal.kub-modal-newConfiguration>
                          <b-icon :icon="headings.newConf.icon" font-scale="1"></b-icon>
                          {{headings.newConf.text}}
                        </b-button>
                        <b-modal id="kub-modal-newConfiguration" size="lg" centered scrollable :title="headings.newConfModal.title" title-tag="h2">
                          <p>{{headings.newConfModal.textInput}}</p>
                          <p v-if="configurationList.length">{{headings.newConfModal.textCart}}</p>
                          <template #modal-footer="{ cancel, ok }">
                            <b-button class="kub-btn mr-2" size="sm" @click="cancel()">
                              Abbrechen
                            </b-button>
                            <b-button class="kub-btn" size="sm" @click="ok(), newConfiguration()">
                              <span class="pl-2 pr-2">OK</span>
                            </b-button>
                          </template>
                        </b-modal>
                      </b-col>
                    </b-row>
                    <app-setup></app-setup>
                  </b-col>
                  <b-col cols="12" lg="6" :class="{'pl-4': lg}">
                    <div :class="{'kub-draft-fixed': lg}">
                      <b-row align-h="between">
                        <b-col cols="auto" :class="[{'pr-1': !lg}, {'pt-2': true}]">
                          <h2 id="kub-heading-draft" class="kub-color">{{headings.draft}}</h2>
                        </b-col>
                        <b-col cols="auto" class="d-lg-none">
                          <b-button v-if="formComplete" block class="kub-btn float-right" v-b-modal.kub-modal-newConfiguration-mobile>
                            <b-icon :icon="headings.newConf.icon" font-scale="1"></b-icon>
                            {{headings.newConf.text}}
                          </b-button>
                          <b-modal id="kub-modal-newConfiguration-mobile" size="xl" centered scrollable :title="headings.newConfModal.title" title-tag="h2">
                            <p>{{headings.newConfModal.textInput}}</p>
                            <p v-if="configurationList.length">{{headings.newConfModal.textCart}}</p>
                            <template #modal-footer="{ cancel, ok }">
                              <b-button class="kub-btn mr-2" size="sm" @click="cancel()">
                                Abbrechen
                              </b-button>
                              <b-button class="kub-btn" size="sm" @click="ok(), newConfiguration()">
                                <span class="pl-2 pr-2">OK</span>
                              </b-button>
                            </template>
                          </b-modal>
                        </b-col>
                      </b-row>
                      <app-draft></app-draft>
                    </div>
                  </b-col>
                </b-row>
              </section>
              <app-price></app-price>
              <app-faq></app-faq>
            </b-card-text>
          </b-tab>
          <b-tab :title-item-class="[{'ml-auto': changeTabIndex === 1}, {'ml-2': true}, {'mr-3': true}, {'kub-main-selection-tabs': true}]" @click="initSummary(), changeView({x: 0, y: 0})">
            <template #title>
              <div class="d-flex align-items-center">
                <b-icon icon="cart4" class="mr-1" :font-scale="md ? 1 : 1.5"></b-icon>
                <span class="kub-main-selection-heading">{{headings.shoppingCart}}</span>
                <span class="ml-1">{{'(' + configurationList.length + ')'}}</span>
              </div>
            </template>
            <b-card-text>
              <app-summary-progress></app-summary-progress>
              <b-row>
                <b-col>
                  <app-summary></app-summary>
                </b-col>
              </b-row>
            </b-card-text>
          </b-tab>
        </b-tabs>
      </b-card>
    </b-container>
    <app-completion v-else class="kub-max-width"></app-completion>
  </main>
</template>

<script>
import Data from '../../data/main/main'
import DataHeader from '../../data/header/header'
import DataForms from '../../data/main/config/setup/form/forms'
import DataMaterial from '../../data/main/config/setup/material/materials'
import DataSetup from '../../data/main/config/setup/setup'
import DataSummary from '../../data/main/summary/summary'

import Shadow from '../header/Shadow.vue'
import Error from '../general/Error.vue'
import ConfigProgress from './config/ConfigProgress.vue'
import Setup from './config/setup/Setup.vue'
import Draft from './config/draft/Draft.vue'
import Price from './config/Price.vue'
import Summary from './summary/Summary.vue'
import SummaryProgress from './summary/SummaryProgress.vue'
import Completion from './completion/Completion.vue'
import FAQ from '../general/FAQ.vue'
import Description from '../general/Description.vue'

import { mapGetters, mapActions } from 'vuex'

export default {
  data () {
    return {
      headings: Data.headings,
      header: DataHeader.header,
      forms: DataForms.forms,
      materials: DataMaterial.materials,
      setupComponents: DataSetup.components,
      summaryComponents: DataSummary.components,
      test: ''
    }
  },
  components: {
    appShadow: Shadow,
    appError: Error,
    appConfigProgress: ConfigProgress,
    appSetup: Setup,
    appDraft: Draft,
    appPrice: Price,
    appSummaryProgress: SummaryProgress,
    appSummary: Summary,
    appCompletion: Completion,
    appFaq: FAQ,
    appDescription: Description
  },
  methods: {
    ...mapActions([
      'setTabIndex',
      'clearSummary',
      'clearRandSides',
      'clearMaterial',
      'clearForm',
      'clearSetup',
      'setRandSides',
      'setDraftFormType',
      'changeView',
      'clearConfigNote',
      'clearCalc',
      'clearConfigPrice',
      'clearConfigOesenTotal',
      'resetFormSelected'
    ]),
    initSummary () {
      if (this.shoppingCartComplete) {
        this.$root.$emit('bv::toggle::collapse', this.summaryComponents.shoppingCart.toggle)
      }
      this.clearSummary()
    },
    newConfiguration () {
      this.$root.$emit('bv::toggle::collapse', this.setupComponents.form.toggle)
      if (this.materialType !== this.materials.pvc600.type) {
        this.$root.$emit('bv::toggle::collapse', this.materials.pvc600.images.toggle)
      }
      this.clearConfigNote()
      this.clearConfigPrice()
      this.clearConfigOesenTotal()
      this.clearRandSides()
      this.setRandSides(this.forms.rechteck.type[0].rand)
      this.clearMaterial()
      this.clearForm()
      this.resetFormSelected()
      this.clearSetup()
      this.setDraftFormType(this.forms.rechteck.type[0].draftFormType)
      this.clearCalc()
    }
  },
  computed: {
    ...mapGetters([
      'xs',
      'sm',
      'md',
      'lg',
      'xl',
      'tabIndex',
      'shoppingCartComplete',
      'configurationList',
      'formComplete',
      'materialType',
      'loadingError',
      'orderLoaded',
      'logoVisible'
    ]),
    changeTabIndex: {
      get () {
        return this.tabIndex
      },
      set (value) {
        this.setTabIndex(value)
      }
    }
  }
}
</script>

<style>
.kub-neg-margin {
  margin-left: -15px !important;
  margin-right: -15px !important;
}

.kub-main {
  background-color: #fff;
  position: relative;
  z-index: 200;
  margin-bottom: 308px;
}

.kub-main-selection {
  border: none !important;
  background-color: #fff !important;
}

.kub-main-selection-tabs {
  border: 1px solid rgba(0, 0, 0, 0.125);
  border-radius: 0.25rem;
}

.kub-draft-fixed {
  position: sticky;
  top: 100px;
}

#kub-logo-dark {
  height: 1.5rem;
  width: auto;
}

@media (max-width: 575px) {
  .kub-main-selection-heading {
    display: none;
  }
}
</style>
